const availableLangObjs = [
  { subPath: '', lang: 'pl' },
  { subPath: 'en', lang: 'en' },
  { subPath: 'ua', lang: 'ua' },
];

export default availableLangObjs;
